import { TrainingProgramsConfig } from './training-program-settings.vm';

export const DEFAULT_TRAINING_PROGRAMS_CONFIG: TrainingProgramsConfig = {
    applicableLocationsConfig: {
        enableApplicableLocations: false,
    },
    trainerAppConfig: {
        allowActions: true,
        enableTrainerSignature: false,
        enableOperatorSignature: false,
        enableUploadEvidence: false,
        taskTypesWithEvidence: [],
    },
};

export const TasksTypes: Record<string, string> = {
    PATIENT_TEST: 'modules.trainings.commons.tasks.patient_test',
    OBSERVED_PATIENT_TEST: 'modules.trainings.commons.tasks.observed_patient_test',
    E_LEARNING: 'modules.trainings.commons.tasks.e_learning',
    QUALITY_CONTROL: 'modules.trainings.commons.tasks.quality_control',
    CUSTOM_MANUAL_TASK: 'modules.trainings.commons.tasks.custom_manual_task',
};

export const TaskTypesOptions: Record<string, string> = Object.keys(TasksTypes).reduce(
    (acc, item) => ({ ...acc, [item]: item }),
    {}
);

export const TaskTypeSelectOptions = Object.entries(TasksTypes).map(([key, translationKey]) => ({
    value: key,
    translationKey,
}));
